import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { NavBarLink } from '../ui-components/global/nav-bar/nav-bar.component';
import { CommonButton } from '../ui-components/global/button/button.component';
import { Router, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SiteWideDialogComponent } from './site-wide-dialog/site-wide-dialog.component';

@Component({
    selector: 'app-site-container',
    templateUrl: './site-container.component.html',
    styleUrls: ['./site-container.component.scss'],
})
export class SiteContainerComponent implements OnInit {
    navBarlinks: NavBarLink[] = [
        {
            title: 'Directory',
            url: '/partners',
        },
        {
            title: 'Social Calendar',
            url: '/events',
        },
        {
            title: 'Magazine',
            url: '/magazine',
        },
    ];
    navBarLinksVisible = true;
    navBarRightButton: CommonButton; /* = {
        title: 'Partner Sign in',
        url: '/dashboard',
        icon: 'person_outline',
        textColor: 'black'
    };*/
    navBarTextColor = 'white';
    navBarBackground = 'transparent';
    navBarOverlay = true;
    footerVisible = true;
    private currentUrl: string;
    constructor(
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object,
        private dialog: MatDialog
    ) {
        this.router.events.subscribe(route => {
            if (route instanceof NavigationEnd) {
                route.url = route.url.split('#')[0];
                this.navBarRightButton = null;
                this.navBarLinksVisible = true;
                this.footerVisible = true;
                /*if (route.url === '/') {
                    this.navBarTextColor = 'white';
                    this.navBarBackground = 'transparent';
                    this.navBarOverlay = true;
                } else {
                    this.navBarTextColor = 'black';
                    this.navBarBackground = 'white';
                    this.navBarOverlay = false;
                    if (route.url === '/apply') {
                        this.navBarLinksVisible = false;
                        this.navBarRightButton = {
                            title: 'Partner Application',
                            type: 'button',
                            textColor: 'black',
                            fill: 'none',
                        };
                        this.footerVisible = false;
                    }
                }
                */
                /* APPLY SPECIFIC SITE */
                this.navBarTextColor = 'black';
                this.navBarBackground = 'white';
                this.navBarOverlay = false;
                this.navBarLinksVisible = false;
                this.navBarRightButton = {
                    title: 'Partner Application',
                    type: 'button',
                    textColor: 'black',
                    fill: 'none',
                };
                this.footerVisible = false;
                /* END APPLY SPECIFIC SITE */
                if (this.currentUrl !== route.url) {
                    if (isPlatformBrowser(this.platformId)) {
                        this.backToTop();
                    }
                    this.currentUrl = route.url;
                }
            }

        });
        /*if (isPlatformBrowser(this.platformId) && localStorage.getItem('swd-betaPlatform') !== 'true') {
            this.dialog.open(SiteWideDialogComponent, {
                data: {
                    message: '<b>Shhh... don’t tell everyone!</b><br><br> We\'re excited to let you try out our beta platform - this is just a small taste of things to come.<br><br> While we continue to build the all-singing and all-dancing Listique platform, this early bird version is best visited with the mindset of a pioneer: by all means explore, look around, but please don’t be alarmed if you come across any strange looking bugs. We are very aware that some things might not be quite as smooth as we would like just yet, but rest assured we are working on it and are making improvements quickly and on a continuous basis.<br><br> We have grand plans for Listique, but we’re welcoming you early because we want to make sure we are building the platform that you want to see and use. We would therefore love to hear your ideas and feedback - just send a message to <a href="mailto:hello@listique.com">hello@listique.com</a> with your thoughts.',
                    acknowledgeButtonText: 'Im ready',
                    acknowledgeKey: 'betaPlatform'
                },
                panelClass: ['dialog-fullwidth-mobile'],
                disableClose: true
            });
        }*/
    }

    ngOnInit() { }

    backToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
